import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const formatMoney = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numericValue);
};

function RelImportacaoNaoEncontrados(items = [], sheetName = "") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const emittedAt = new Date();
  const emittedLabel = `${String(emittedAt.getDate()).padStart(2, "0")}/${String(
    emittedAt.getMonth() + 1,
  ).padStart(2, "0")}/${emittedAt.getFullYear()}`;

  const body = [
    [
      { text: "LINHA", style: "tableHeader" },
      { text: "NOME", style: "tableHeader" },
      { text: "SIAPE", style: "tableHeader" },
      { text: "CPF", style: "tableHeader" },
      { text: "ORGAO", style: "tableHeader" },
      { text: "VALOR", style: "tableHeader" },
    ],
    ...items.map((item) => [
      { text: String(item.rowNumber || "-"), fontSize: 9 },
      { text: item.nome || "-", fontSize: 9 },
      { text: item.siape || "-", fontSize: 9 },
      { text: item.cpf || "-", fontSize: 9 },
      { text: item.orgao || "-", fontSize: 9 },
      { text: formatMoney(item.valor), fontSize: 9, alignment: "right" },
    ]),
  ];

  const docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [20, 70, 20, 35],
    header: {
      margin: [20, 15, 20, 0],
      stack: [
        { text: "Importacao de associados - nao encontrados", bold: true, fontSize: 15 },
        {
          text: `Competencia/aba: ${sheetName || "-"}   Emissao: ${emittedLabel}   Registros: ${items.length}`,
          fontSize: 10,
          margin: [0, 6, 0, 0],
        },
      ],
    },
    content: [
      {
        table: {
          headerRows: 1,
          widths: [45, "*", 70, 90, "*", 80],
          body,
        },
        layout: "lightHorizontalLines",
      },
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
}

export default RelImportacaoNaoEncontrados;
